import { apiCallSolveApprovalData } from "../../api/approve-reject-api/api-call-solve-approval-data";
import {
  TCorePage,
  TDataApproveRejectAction,
  TDescriptionType
} from "../../Types";
import getCleanPoolStore from "../core/core-clean-pool";
import getCorePersonalStore from "../core/core-personal-store";
import getCorePopUpStore from "../core/core-popup-store";
import getSuccessApproveRejectStatus from "./success-approve-reject-status";

const approveUserDescriptionOnDatabase = async (
  descriptionID: number,
  userId: number,
  userUUID: string,
  from: TCorePage,
  descriptionType: TDescriptionType,
  resolvingPendindData: boolean
) => {
  const adminUserId = getCorePersonalStore().user.get().id;
  const isSelfDescription = descriptionType === "self_description";
  const action: TDataApproveRejectAction = isSelfDescription
    ? "approve_description"
    : "approve_peer_description";
  const { status, code } = await apiCallSolveApprovalData({
    descriptionID,
    adminUserId,
    userUUID,
    action,
    from,
    imageID: "",
    resolvingPendindData
  });
  if (status === "OK") {
    getSuccessApproveRejectStatus().approveDescriptionClient(
      descriptionType,
      from,
      userId,
      isSelfDescription,
      resolvingPendindData
    );
  } else {
    if (code === "NO_LONGER_ACTIVE_POOL") {
      await getCleanPoolStore().automaticCleanPool({ type: "APPROVAL" });
    }
    getCorePopUpStore().showAlertMessage(code);
  }
};

export default approveUserDescriptionOnDatabase;
